import React from 'react';
import { Link } from 'react-router-dom';
import { AmountDisplay, FiatValueDisplay, useHoldings } from '@onomy/react-hub';

import { PrimaryButton } from 'components/Modals/styles';
import {
  Balances,
  Balance,
  BalancePrice,
  BalanceNumber,
  Hint,
  TooltipCaption,
  TooltipDesc,
  TrimmedApproved,
  WithdrawBtnWrapper,
} from './SidebarStyles';
import { useExchange } from 'context/exchange/ExchangeContext';
import { HiddenMockup } from 'components/Modals/components/HiddenMockup';

export default function SidebarBalances() {
  const { ethTotal, bNomTotal } = useHoldings();
  const { bNomSellAllowance } = useExchange();

  return (
    <Balances>
      <Balance>
        <BalancePrice>
          <strong>ETH Balance</strong>
          <BalanceNumber>
            <AmountDisplay balance={ethTotal} SymbolComponent={null} />
            <small>
              <FiatValueDisplay value={ethTotal.fiatValue} />
            </small>
          </BalanceNumber>
        </BalancePrice>
        <Hint>
          <TooltipCaption>ETH Balance</TooltipCaption>
          <TooltipDesc>This is your connected wallet Ether balance.</TooltipDesc>
        </Hint>
      </Balance>
      <Balance>
        <BalancePrice>
          <strong>bNOM Balance</strong>
          <BalanceNumber strong>
            <AmountDisplay balance={bNomTotal} SymbolComponent={null} />
            <small>
              <FiatValueDisplay value={bNomTotal.fiatValue} />
            </small>
            <TrimmedApproved value={bNomSellAllowance.amountFormatted} />
            {/* <CloseIcon onClick={() => {}} /> */}
          </BalanceNumber>
        </BalancePrice>
        <Hint>
          <TooltipCaption>bNOM Balance</TooltipCaption>
          <TooltipDesc>
            This shows your total bNOM balance and the amount approved for selling. You must approve
            bNOM for selling before it can be sold.
          </TooltipDesc>
        </Hint>
      </Balance>

      <WithdrawBtnWrapper>
        <HiddenMockup>
          <Link to="/bridge-initial">
            <PrimaryButton style={{ width: '100%' }}>Bridge bNOM to NOM</PrimaryButton>
          </Link>
        </HiddenMockup>
      </WithdrawBtnWrapper>
    </Balances>
  );
}
